import styled from "styled-components/macro";
import { device } from "../../../device";

export const StyledNavbar = styled.nav`
	border: 1px solid #dfe3e8;
	width: 100%;

	background: #f4f6f8;

	position: sticky;
	top: 0;
	z-index: 10;
`;

export const StyledSignIn = styled.div`
	margin-top: 1rem;
`;

export const FormContainer = styled.div`
	margin: 0 auto;
	width: calc(100% - 2rem);
	display: flex;
	flex-direction: column;
	justify-content: normal;
`;

export const StyledInput = styled.input`
	background: #f5f5f5 !important;
	border: 1px solid #dbdbdb !important;
	box-sizing: border-box !important;
	border-radius: 2.03125px !important;
	padding: 0.6rem !important;
	width: 100% !important;
	margin-bottom: 0.5rem !important;
`;

export const StyledLabel = styled.label`
	color: #272b2f;
	opacity: 0.5;
	margin-bottom: 0.5rem;
`;

export const StyledWrapperInput = styled.div`
	display: flex;
	gap: 1rem;
`;

export const StyledForm = styled.form``;

export const StyledFormWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: 525px;
	@media ${device.tablet} {
		grid-template-columns: 1fr;
	}
`;

export const StyledLeftForm = styled.div`
	background: #ffffff;
	padding: 1rem 1.6rem 2.2rem 1.6rem;
	align-items: center;
	text-align: left;
	display: grid;
	grid-template-rows: clamp(2rem, 4rem, 20%) 1fr;
	@media ${device.tablet} {
		padding: 2.2rem 0 2.2rem 0;
	}
`;

export const StyledRightForm = styled.div`
	padding: 1.6rem;
	display: flex;
	align-items: center;
	justify-content: center;
	background: linear-gradient(223.75deg, #f2be41 0%, #fcefcf 100%), #ffffff;
`;

export const StyledStar = styled.i`
	color: red;
	&:before {
		content: " ";
		white-space: pre;
	}
`;

export const StyledButton = styled.button`
	background: #f1c232;
	color: #111111;
	border-radius: 5px;
	padding: 8px 12px;
	border: none;
	cursor: pointer;
	width: 100%;
	min-height: 42px;
	&:disabled {
		background-color: #cccccc;
		color: #666666;
	}
`;

export const GoogleButton = styled.button`
	cursor: pointer;
	height: 2.5rem;
	background: #4285f4;
	width: 100%;
	border: none;
	color: #ffffff;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 0.5rem;
	min-height: 42px;
	border-radius: 5px;
`;

export const Row = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;
`;

export const FixelLogo = styled.img`
	margin: 2rem 0;
`;

export const StyledSubTitle = styled.h2`
	margin: 4rem 0 2rem 0;
	text-align: center;
`;

export const StyledMidBoxes = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-evenly;
	gap: 2rem;
	@media ${device.tablet} {
		flex-wrap: wrap;
	}
`;

export const MidBox = styled.div`
	background: #ffffff;
	padding: 2rem;
	a {
		z-index: 1;
		cursor: pointer;
	}
`;

export const MidBoxIcon = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	background: #6270c6;
	border-radius: 50%;
	color: #ffffff;
	width: 48px;
	height: 48px;
	margin: 1rem auto 0 auto;
`;

export const MidBoxTitle = styled.h4`
	color: #272b2f;
	font-size: 18px;
	line-height: 27px;
	text-align: center;
	margin: 1.4rem 0;
`;

export const StyledDescription = styled.p`
	font-size: 14px;
	line-height: 21px;
	text-align: center;
	opacity: 0.6;
`;
